/** Display labels for Programme Admission Profile configuration. Not legal conclusions. */

export const INTENDED_TREATMENTS = [
  { value: 'AUTHORITATIVE_CANDIDATE', label: 'Authoritative candidate' },
  { value: 'REPOSITORY_ONLY', label: 'Repository only' },
  { value: 'MIXED', label: 'Mixed' },
];

export const INSTRUMENT_TYPES = [
  { value: 'ARTICLE_3_NOTE', label: 'Article 3 note' },
  { value: 'RETAIL_INSTALLMENT_CONTRACT', label: 'Retail installment contract' },
  { value: 'LEASE', label: 'Lease' },
  { value: 'SECURITY_AGREEMENT', label: 'Security agreement' },
  { value: 'MORTGAGE', label: 'Mortgage' },
  { value: 'DOCUMENT_OF_TITLE', label: 'Document of title' },
  { value: 'OTHER_AGREEMENT', label: 'Other agreement' },
];

export const LEGAL_REGIMES = [
  { value: 'UETA_16', label: 'UETA §16' },
  { value: 'ESIGN_201', label: 'ESIGN §201' },
  { value: 'UCC_9_105', label: 'UCC §9-105' },
  { value: 'UCC_7_106', label: 'UCC §7-106' },
  { value: 'UCC_12_105_FUTURE', label: 'UCC §12-105 (Future)' },
  { value: 'NONE', label: 'None' },
];

export const CONTROL_PROFILES = [
  { value: 'NONE', label: 'None' },
  { value: 'SINGLE_AUTHORITATIVE_COPY', label: 'Single authoritative copy' },
];

export const SOURCE_FORMS = [
  { value: 'BORN_DIGITAL', label: 'Born digital' },
  { value: 'SCANNED_PAPER', label: 'Scanned paper' },
  { value: 'MIXED', label: 'Mixed' },
  { value: 'UNKNOWN', label: 'Unknown' },
];

export const DISPOSITIONS = [
  { value: 'BLOCK', label: 'Block' },
  { value: 'REVIEW', label: 'Review' },
];

export const PROFILE_STATUS = {
  DRAFT: {
    label: 'Draft',
    tone: 'neutral',
    description: 'Not used for new submissions.',
  },
  APPROVED: {
    label: 'Approved — not live',
    tone: 'warning',
    description:
      'This profile has been approved in the application but is not the active programme policy. Submissions require an active profile.',
  },
  ACTIVE: {
    label: 'Active programme policy',
    tone: 'info',
    description: 'Live for subsequent submissions.',
  },
  SUPERSEDED: {
    label: 'Superseded',
    tone: 'neutral',
    description: 'This profile is historical and cannot be changed here.',
  },
  RETIRED: {
    label: 'Retired',
    tone: 'neutral',
    description: 'This profile is historical and cannot be changed here.',
  },
};

export function profileStatusView(status) {
  return (
    PROFILE_STATUS[status] || {
      label: status || 'Unknown',
      tone: 'neutral',
      description: 'This profile is read-only.',
    }
  );
}
